import React, { useState, Children } from 'react';
import { BarChart2Icon, TrendingUpIcon, HeadphonesIcon, DollarSignIcon, SettingsIcon, HomeIcon, LogOutIcon, LayoutDashboardIcon, ChevronDownIcon, ChevronRightIcon, ShoppingCartIcon, PackageIcon, MapPinIcon, UsersIcon, TrendingDownIcon, FileTextIcon, MegaphoneIcon, MousePointerClickIcon, RocketIcon, StoreIcon, TargetIcon, WrenchIcon, ShieldCheckIcon, AlertTriangleIcon, PieChartIcon, CreditCardIcon, BarChart3Icon, WalletIcon, BuildingIcon, LineChartIcon, TruckIcon, BoxIcon, ClockIcon, AlertCircleIcon, GlobeIcon, FactoryIcon, ActivityIcon, ZapIcon, ThermometerIcon } from 'lucide-react';
interface SidebarProps {
  activeSection: string;
  setActiveSection: (section: string) => void;
}
interface NavItem {
  name: string;
  icon: React.ReactNode;
  children?: NavItem[];
}
const Sidebar: React.FC<SidebarProps> = ({
  activeSection,
  setActiveSection
}) => {
  const [expandedSections, setExpandedSections] = useState<string[]>(['Executive Summary', 'Sales', 'Marketing', 'After-Sales', 'Finance', 'Supply Chain', 'Operations', 'Manufacturing', 'Audits & Compliance']);
  const navigationItems: NavItem[] = [{
    name: 'Executive Summary',
    icon: <LayoutDashboardIcon size={18} data-id="element-11549" />,
    children: [{
      name: 'Overview',
      icon: <HomeIcon size={16} data-id="element-11550" />
    }, {
      name: 'Risks & Opportunities',
      icon: <AlertTriangleIcon size={16} data-id="element-11551" />
    }, {
      name: 'Leadership KPIs',
      icon: <TargetIcon size={16} data-id="element-11552" />
    }, {
      name: 'Plant Benchmarking',
      icon: <BarChart3Icon size={16} data-id="element-11553" />
    }]
  }, {
    name: 'Sales',
    icon: <BarChart2Icon size={18} data-id="element-11554" />,
    children: [{
      name: 'Sales Overview',
      icon: <HomeIcon size={16} data-id="element-11555" />
    }, {
      name: 'OEM Sales',
      icon: <BuildingIcon size={16} data-id="element-11556" />
    }, {
      name: 'Aftermarket Sales',
      icon: <ShoppingCartIcon size={16} data-id="element-11557" />
    }, {
      name: 'Product Line Performance',
      icon: <PackageIcon size={16} data-id="element-11558" />
    }, {
      name: 'Regional Sales',
      icon: <MapPinIcon size={16} data-id="element-11559" />
    }, {
      name: 'Customer Profitability',
      icon: <UsersIcon size={16} data-id="element-11560" />
    }, {
      name: 'Sales Forecasting',
      icon: <TrendingUpIcon size={16} data-id="element-11561" />
    }, {
      name: 'Order Book vs Deliveries',
      icon: <FileTextIcon size={16} data-id="element-11562" />
    }, {
      name: 'New Business Pipeline',
      icon: <RocketIcon size={16} data-id="element-11563" />
    }]
  }, {
    name: 'Marketing',
    icon: <TrendingUpIcon size={18} data-id="element-11564" />,
    children: [{
      name: 'Marketing Overview',
      icon: <HomeIcon size={16} data-id="element-11565" />
    }, {
      name: 'Campaign Performance',
      icon: <MegaphoneIcon size={16} data-id="element-11566" />
    }, {
      name: 'Digital Analytics',
      icon: <MousePointerClickIcon size={16} data-id="element-11567" />
    }, {
      name: 'Product Launch Tracker',
      icon: <RocketIcon size={16} data-id="element-11568" />
    }, {
      name: 'Dealer Performance',
      icon: <StoreIcon size={16} data-id="element-11569" />
    }, {
      name: 'Market Share Analysis',
      icon: <TargetIcon size={16} data-id="element-11570" />
    }, {
      name: 'Channel ROI Analysis',
      icon: <LineChartIcon size={16} data-id="element-11571" />
    }]
  }, {
    name: 'After-Sales',
    icon: <HeadphonesIcon size={18} data-id="element-11572" />,
    children: [{
      name: 'Service Overview',
      icon: <HomeIcon size={16} data-id="element-11573" />
    }, {
      name: 'Warranty Claims',
      icon: <ShieldCheckIcon size={16} data-id="element-11574" />
    }, {
      name: 'AMC Contracts',
      icon: <FileTextIcon size={16} data-id="element-11575" />
    }, {
      name: 'Spare Parts Inventory',
      icon: <BoxIcon size={16} data-id="element-11576" />
    }, {
      name: 'Technician Performance',
      icon: <WrenchIcon size={16} data-id="element-11577" />
    }, {
      name: 'Predictive Maintenance',
      icon: <AlertCircleIcon size={16} data-id="element-11578" />
    }, {
      name: 'Root Cause Analysis',
      icon: <div size={16} data-id="element-11579" />
    }]
  }, {
    name: 'Finance',
    icon: <DollarSignIcon size={18} data-id="element-11580" />,
    children: [{
      name: 'Financial Overview',
      icon: <HomeIcon size={16} data-id="element-11581" />
    }, {
      name: 'P&L by Business Line',
      icon: <PieChartIcon size={16} data-id="element-11582" />
    }, {
      name: 'Cost Analytics',
      icon: <CreditCardIcon size={16} data-id="element-11583" />
    }, {
      name: 'Working Capital',
      icon: <WalletIcon size={16} data-id="element-11584" />
    }, {
      name: 'Capex Tracking',
      icon: <BuildingIcon size={16} data-id="element-11585" />
    }, {
      name: 'Plant Cost Comparison',
      icon: <BarChart3Icon size={16} data-id="element-11586" />
    }, {
      name: 'Scenario Modelling',
      icon: <LineChartIcon size={16} data-id="element-11587" />
    }]
  }, {
    name: 'Supply Chain',
    icon: <TruckIcon size={18} data-id="element-11588" />,
    children: [{
      name: 'Supply Chain Overview',
      icon: <HomeIcon size={16} data-id="element-11589" />
    }, {
      name: 'Vendor Performance',
      icon: <UsersIcon size={16} data-id="element-11590" />
    }, {
      name: 'Procurement Cost Trends',
      icon: <TrendingDownIcon size={16} data-id="element-11591" />
    }, {
      name: 'Lead Time & Logistics',
      icon: <ClockIcon size={16} data-id="element-11592" />
    }, {
      name: 'Material Risk Alerts',
      icon: <AlertTriangleIcon size={16} data-id="element-11593" />
    }, {
      name: 'Import/Export Tracker',
      icon: <GlobeIcon size={16} data-id="element-11594" />
    }]
  }, {
    name: 'Operations',
    icon: <FactoryIcon size={18} data-id="element-11595" />,
    children: [{
      name: 'Plant Overview',
      icon: <HomeIcon size={16} data-id="element-11596" />
    }, {
      name: 'Production Output',
      icon: <ActivityIcon size={16} data-id="element-11597" />
    }, {
      name: 'Capacity Utilization',
      icon: <BarChart3Icon size={16} data-id="element-11598" />
    }, {
      name: 'Downtime Analysis',
      icon: <AlertCircleIcon size={16} data-id="element-11599" />
    }, {
      name: 'Quality Metrics',
      icon: <ShieldCheckIcon size={16} data-id="element-11600" />
    }, {
      name: 'OEE Dashboards',
      icon: <ZapIcon size={16} data-id="element-11601" />
    }, {
      name: 'Energy Consumption',
      icon: <ThermometerIcon size={16} data-id="element-11602" />
    }]
  }, {
    name: 'Manufacturing',
    icon: <FactoryIcon size={18} data-id="element-11603" />,
    children: [{
      name: 'Manufacturing Overview',
      icon: <HomeIcon size={16} data-id="element-11604" />
    }, {
      name: 'Production Output',
      icon: <ActivityIcon size={16} data-id="element-11605" />
    }, {
      name: 'Capacity Utilization',
      icon: <BarChart3Icon size={16} data-id="element-11606" />
    }, {
      name: 'Downtime & Breakdown Analysis',
      icon: <AlertCircleIcon size={16} data-id="element-11607" />
    }, {
      name: 'Quality Metrics',
      icon: <ShieldCheckIcon size={16} data-id="element-11608" />
    }, {
      name: 'OEE',
      icon: <ZapIcon size={16} data-id="element-11609" />
    }, {
      name: 'Line-Level Performance',
      icon: <BarChart3Icon size={16} data-id="element-11610" />
    }, {
      name: 'Process Parameters & Tooling',
      icon: <SettingsIcon size={16} data-id="element-11611" />
    }, {
      name: 'Scrap Cost Analysis',
      icon: <TrendingDownIcon size={16} data-id="element-11612" />
    }, {
      name: 'Energy Consumption & Cost',
      icon: <ThermometerIcon size={16} data-id="element-11613" />
    }]
  }, {
    name: 'Audits & Compliance',
    icon: <ShieldCheckIcon size={18} data-id="element-11614" />,
    children: [{
      name: 'Audit Overview',
      icon: <HomeIcon size={16} data-id="element-11615" />
    }, {
      name: 'Internal Audits',
      icon: <FileTextIcon size={16} data-id="element-11616" />
    }, {
      name: 'External OEM Audits',
      icon: <BuildingIcon size={16} data-id="element-11617" />
    }, {
      name: 'Certification Compliance',
      icon: <ShieldCheckIcon size={16} data-id="element-11618" />
    }, {
      name: 'NCR Tracker',
      icon: <AlertTriangleIcon size={16} data-id="element-11619" />
    }, {
      name: 'CAPA',
      icon: <TargetIcon size={16} data-id="element-11620" />
    }, {
      name: 'Safety Incidents',
      icon: <AlertCircleIcon size={16} data-id="element-11621" />
    }, {
      name: 'Environmental Compliance',
      icon: <GlobeIcon size={16} data-id="element-11622" />
    }, {
      name: 'Documentation Status',
      icon: <FileTextIcon size={16} data-id="element-11623" />
    }]
  }];
  const toggleSection = (sectionName: string) => {
    if (expandedSections.includes(sectionName)) {
      setExpandedSections(expandedSections.filter(s => s !== sectionName));
    } else {
      setExpandedSections([...expandedSections, sectionName]);
    }
  };
  const handleItemClick = (itemName: string, hasChildren: boolean) => {
    if (hasChildren) {
      toggleSection(itemName);
    } else {
      setActiveSection(itemName);
    }
  };
  return <div className="flex flex-col h-full" data-id="element-11624">
      {/* Logo area */}
      <div className="h-16 flex items-center justify-center border-b border-gray-200" data-id="element-11625">
        <div className="text-gray-800 font-semibold text-lg flex items-center" data-id="element-11626">
          <HomeIcon className="mr-2" size={24} data-id="element-11627" />
          <span data-id="element-11628">AutoDash</span>
        </div>
      </div>
      {/* Navigation items */}
      <nav className="flex-grow mt-4 overflow-y-auto" data-id="element-11629">
        <ul className="space-y-1" data-id="element-11630">
          {navigationItems.map(item => <li key={item.name} className="px-3" data-id="element-11631">
              <button onClick={() => handleItemClick(item.name, !!item.children)} className={`flex items-center justify-between w-full px-3 py-2.5 rounded-lg transition-colors ${activeSection === item.name && !item.children ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-11632">
                <div className="flex items-center min-w-0 flex-1" data-id="element-11633">
                  <span className="flex items-center justify-center w-5 h-5 mr-3 flex-shrink-0" data-id="element-11634">
                    {item.icon}
                  </span>
                  <span className="font-medium text-sm truncate" data-id="element-11635">
                    {item.name}
                  </span>
                </div>
                {item.children && <span className="flex items-center justify-center ml-2 flex-shrink-0" data-id="element-11636">
                    {expandedSections.includes(item.name) ? <ChevronDownIcon size={16} data-id="element-11637" /> : <ChevronRightIcon size={16} data-id="element-11638" />}
                  </span>}
              </button>
              {/* Sub-items */}
              {item.children && expandedSections.includes(item.name) && <ul className="mt-1 space-y-1" data-id="element-11639">
                  {item.children.map(child => <li key={child.name} className="pl-8" data-id="element-11640">
                      <button onClick={() => setActiveSection(child.name)} className={`flex items-center w-full px-3 py-2 rounded-lg transition-colors text-sm ${activeSection === child.name ? 'bg-blue-50 text-blue-700 font-medium' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`} data-id="element-11641">
                        <span className="flex items-center justify-center w-4 h-4 mr-3 flex-shrink-0" data-id="element-11642">
                          {child.icon}
                        </span>
                        <span className="truncate" data-id="element-11643">{child.name}</span>
                      </button>
                    </li>)}
                </ul>}
            </li>)}
        </ul>
      </nav>
      {/* User area */}
      <div className="p-4 border-t border-gray-200" data-id="element-11644">
        <button className="flex items-center text-gray-600 hover:text-gray-900 w-full px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-11645">
          <LogOutIcon size={20} className="mr-3" data-id="element-11646" />
          <span data-id="element-11647">Logout</span>
        </button>
      </div>
    </div>;
};
export default Sidebar;